import { api } from '@/api';
import { CASES_LIST_TAG, MATTER_ABOUT_TAG } from '@/api/constants';

export interface PostMatterDocumentBulkUploadCompleteRequest {
  matterId: string;
  fletchDocumentIds: string[];
}

const matterDocumentBulkUploadCompleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postMatterDocumentBulkUploadComplete: builder.mutation<void, PostMatterDocumentBulkUploadCompleteRequest>({
      query: (body) => ({
        url: '/matter/document-upload/bulk-upload-complete',
        method: 'POST',
        body,
      }),
      // The case gains files that are still processing, so the cases list (and the
      // "files are still processing" state it carries) is stale once this resolves.
      invalidatesTags: (_result, _error, { matterId }) => [
        { type: CASES_LIST_TAG },
        { type: MATTER_ABOUT_TAG, id: matterId },
      ],
    }),
  }),
});

export const { usePostMatterDocumentBulkUploadCompleteMutation } = matterDocumentBulkUploadCompleteApi;
